// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneConfirmationAPIModel
 */
export interface PhoneConfirmationAPIModel {
    /**
     * 
     * @type {string}
     * @memberof PhoneConfirmationAPIModel
     */
    code: string;
}

export function PhoneConfirmationAPIModelFromJSON(json: any): PhoneConfirmationAPIModel {
    return PhoneConfirmationAPIModelFromJSONTyped(json, false);
}

export function PhoneConfirmationAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneConfirmationAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function PhoneConfirmationAPIModelToJSON(value?: PhoneConfirmationAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}


